import Modal from 'components/Modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';
import IntlHelper from 'utils/helpers/intl.helper';

export const InputContainer = styled.div`
  margin-top: 5px;
  text-align: center;
`;

const ContinueWithoutSaving = () => {
  const dispatch = useDispatch();
  const t = IntlHelper.useTranslator();
  const { forceValidation } = useSelector(selectors.modal.getModalProps);

  const handleConfirm = () => {
    try {
      forceValidation(false);
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <>
      <Modal.Header title={t('continue_without_saving?')} subtitle={t('you_should_save_before')} />
      <Modal.Footer confirmText={t('continua')} confirmAction={handleConfirm} closeButtonText={t('annulla')} />
    </>
  );
};

export default ContinueWithoutSaving;
